module.exports = __webpack_public_path__ + "static/Document Exchange 3-9207d51b2c1523aeccf036b86c180500.png";